"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeOrgName = void 0;
const sanitizeOrgName = (orgName) => {
    // Remove all non-alphanumeric characters except - and replace with _
    const orgNameSanitized = orgName.replace(/[^a-zA-Z0-9-]/g, '_');
    // lover case the string
    const lowerOrgName = orgNameSanitized.toLowerCase();
    return lowerOrgName;
};
exports.sanitizeOrgName = sanitizeOrgName;
